// Bulk-animate duration picker (product directive: pick the animation
// duration from the element's on-screen time). Screen time <= 5s -> a ~5s
// clip is fine (floor the target at 5 so a 1s-on-screen image doesn't get
// the shortest available option); screen time > 5s -> pick whichever
// supported duration is numerically closest, ties broken toward the larger
// one, then clamped into the supported range. Unknown/invalid screen time
// (null timing, e.g. whole-scene images) returns undefined so the caller
// omits durationSec and the server default applies.
export function pickAnimationDuration(screenTimeSec, supportedDurations) {
  if (
    screenTimeSec == null ||
    !Number.isFinite(screenTimeSec) ||
    !Array.isArray(supportedDurations) ||
    !supportedDurations.length
  ) {
    return undefined;
  }
  const target = Math.max(screenTimeSec, 5);
  const min = Math.min(...supportedDurations);
  const max = Math.max(...supportedDurations);
  const clamped = Math.min(Math.max(target, min), max);
  return supportedDurations.reduce((best, candidate) => {
    const bestDist = Math.abs(best - clamped);
    const candidateDist = Math.abs(candidate - clamped);
    if (candidateDist < bestDist) return candidate;
    if (candidateDist === bestDist && candidate > best) return candidate;
    return best;
  }, supportedDurations[0]);
}
